<template>
    <div
        class="aon-radio-group"
        :class="{
            'remove-margins': removeMargins,
            'error-alert': error,
            [direction]: true,
            'disabled': disabled,
        }"
    >
        <AonAlertBox
            v-if="error"
            class="mb-2"
            :isContextual="true"
            :title="errorOptions.errorMsg"
            type="error"
        />
        <p v-if="title" :class="['strong', `${!description ? 'mb-3' : 'mb-1'}`]">{{ title }}</p>
        <p v-if="description" class="mb-2">{{ description }}</p>
        <div class="radio-container">
            <div
                v-for="item in options"
                :key="item.label + '_key'"
                class="radio-button"
                :class="item.classes"
            >
                <label
                    :class="[
                        'label',
                        { disabled: item.disabled },
                        'mr-4',
                        labelCssClass,
                    ]"
                >
                    <input
                        v-model="picked"
                        :value="item.value"
                        class="mr-2"
                        :tabindex="item.disabled ? '-1' : '0'"
                        type="radio"
                        @click="onRadioBtnClicked(item)"
                    />
                    {{ item.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import AonAlertBox from '../AonAlertBox.vue';

const emit = defineEmits(['clicked', 'update:modelValue']);

const props = defineProps({
    options: {
        type: Array,
        default: () => {
        },
    },
    modelValue: {
        type: String,
        default: () => null,
    },
    /**
     * @deprecated Use `modelValue` instead. This prop is not reactive
     */
    initSelection: {
        type: String,
        default: '',
    },
    title: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    direction: {
        type: String,
        default: 'horiz',
        validator: v => ['horiz', 'vert'].includes(v),
    },
    removeMargins: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    // Hoping to have some sort of validator for errors
    error: {
        type: Boolean,
        default: false,
    },
    errorOptions: {
        type: Object,
        default: () => {
            return {
                errorMsg: ''
            }
        },
    },
    labelCssClass: {
        type: String,
        default: null,
    },
})

watch(
    () => props.modelValue,
    (selected) => {
        picked.value = selected;
    }
);

const picked = ref(
    props.modelValue
        ? props.modelValue
        : props.initSelection
            ? props.initSelection
            : false
);

const onRadioBtnClicked = (item) => {
    emit('update:modelValue', item.value);

    // deprecated
    emit('clicked', item.value);
}

</script>

<script>
export default {
    name: 'AonRadioGroup'
}
</script>

<style lang="scss">
.aon-radio-group {
    &.vert {
        .radio-container {
            flex-direction: column;

            .radio-button {
                margin: 4px 0;
            }
        }
    }

    &.vert {
        .radio-container {
            flex-direction: column;
        }

        .radio-button {
            margin: 4px 0;
        }

    }

    .radio-container {
        display: flex;

        .radio-button {
            display: flex;
            position: relative;
        }
    }

    &.remove-margins {
        padding: 0;
        width: 25px;
        height: 25px;
        margin: 0;
    }

    .radio-container {
        &.remove-margins {
            padding: 0;
            width: 25px;
            height: 25px;
            margin: 0 0 0 5px;
        }
    }
}
</style>
